import { useTranslation } from 'react-i18next';
import { Input, InputRef } from 'antd';
import { Button } from 'syngenta-digital-cropwise-react-ui-kit';
import React, { useRef } from 'react';

export const CustomSearchDropdown = ({
  setValue,
  clearValue,
  value,
  onApply,
}: {
  setValue: (value: string) => void;
  clearValue?: () => void;
  value: string;
  onApply: (value: string) => void;
}) => {
  const { t } = useTranslation();
  const searchInput = useRef<InputRef>(null);
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value);

  return (
    <div className="flex flex-col p-8 w-230px min-h-110px justify-between">
      <div className="flex flex-col p-6">
        <Input
          ref={searchInput}
          placeholder={`Search`}
          value={value}
          onChange={handleOnChange}
          onPressEnter={() => onApply(value)}
          data-cy="custom-search-dropdown-input"
        />
      </div>
      <div className="flex justify-between p-6">
        <Button
          size="small"
          onClick={clearValue}
          data-testid="clear-button"
          data-cy="custom-search-dropdown-clear"
        >
          {t('resource-mapper.clear')}
        </Button>
        <Button
          size="small"
          color="green"
          className="bg-green-60 text-neutral-00 hover:bg-green-70 focus:bg-green-70 hover:text-neutral-00 focus:text-neutral-00"
          onClick={() => {
            onApply(value);
          }}
          data-cy="custom-search-dropdown-apply"
          data-testid="apply-button"
        >
          {t('resource-mapper.apply')}
        </Button>
      </div>
    </div>
  );
};
